export default __webpack_public_path__ + "static/media/rockspring.9405bf3f.jpg";